import { motion } from 'framer-motion';

const bubbles = [
  { size: 60, x: '10%', y: '20%', delay: 0, duration: 18, color: 'sky' },
  { size: 40, x: '80%', y: '10%', delay: 2, duration: 22, color: 'pink' },
  { size: 80, x: '70%', y: '60%', delay: 1, duration: 20, color: 'sky' },
  { size: 30, x: '20%', y: '70%', delay: 3, duration: 16, color: 'pink' },
  { size: 50, x: '90%', y: '40%', delay: 0.5, duration: 19, color: 'sky' },
  { size: 45, x: '5%', y: '50%', delay: 2.5, duration: 21, color: 'pink' },
  { size: 35, x: '60%', y: '80%', delay: 1.5, duration: 17, color: 'sky' },
  { size: 55, x: '40%', y: '15%', delay: 3.5, duration: 23, color: 'pink' },
  { size: 25, x: '95%', y: '75%', delay: 4, duration: 15, color: 'sky' },
  { size: 70, x: '30%', y: '45%', delay: 0.8, duration: 24, color: 'pink' },
];

export const BubbleBackground = () => {
  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden z-0" aria-hidden="true">
      {bubbles.map((bubble, index) => (
        <motion.div
          key={index}
          className={`absolute rounded-full ${
            bubble.color === 'sky' 
              ? 'bg-gradient-to-br from-sky-200 to-sky-400' 
              : 'bg-gradient-to-br from-pink-200 to-pink-400'
          }`}
          style={{
            width: bubble.size,
            height: bubble.size,
            left: bubble.x,
            top: bubble.y,
            opacity: 0.15,
          }}
          animate={{
            y: [0, -30, -15, -40, 0],
            x: [0, 15, -10, 5, 0],
            scale: [1, 1.05, 0.98, 1.02, 1],
          }}
          transition={{
            duration: bubble.duration,
            delay: bubble.delay,
            repeat: Infinity,
            ease: 'easeInOut',
          }}
        />
      ))}
    </div>
  );
};

export default BubbleBackground;
